import { render, staticRenderFns } from "./GraphDetail34.vue?vue&type=template&id=72876257&scoped=true&"
import script from "./GraphDetail34.vue?vue&type=script&lang=js&"
export * from "./GraphDetail34.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72876257",
  null
  
)

export default component.exports